import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=15c7ee90"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports